<script>
import {
  monCompteCommandeMagasinOverviewProps,
  useMonCompteCommandeMagasinOverview
} from "./mixin";
import Divider from "@/components/atoms/divider";
import Icon from "@/components/atoms/icon";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Card from "@/components/molecules/card";
import BadgeStatus from "@/components/molecules/badge-status";
import Button from "@/components/atoms/button";
import DropDown from "@/components/molecules/drop-down";
import DropDownItem from "@/components/molecules/drop-down/drop-down-item";

export default {
  name: "CommandeOverviewMobile",
  components: {
    Divider,
    GridRow,
    GridCol,
    Card,
    Icon,
    BadgeStatus,
    Button,
    DropDown,
    DropDownItem
  },
  props: {
    ...monCompteCommandeMagasinOverviewProps()
  },
  setup(props) {
    const { commandeListReversed, ouvrirPdf } =
      useMonCompteCommandeMagasinOverview(props);
    return { commandeListReversed, ouvrirPdf };
  }
};
</script>

<template>
  <Card
    radius="lg"
    elevation="sm"
  >
    <div class="c-commande-overview-mobile__button u-p-sm">
      <div class="u-flex u-flex-align-center">
        <div class="u-flex-item-fluid u-pr-md">
          <GridRow class="u-text-left u-pb-xs">
            <GridCol cols="8">
              <div class="u-flex u-flex-column u-flex-column-reverse">
                <p class="u-text-ellipsis u-font-15">
                  {{ commande.attributes.numero_ticket_de_caisse }}
                </p>
                <p class="u-font-15 u-font-500 u-mb-xxs">
                  {{ dateCommande(commande.attributes.date) }}
                </p>
              </div>
            </GridCol>
            <GridCol cols="4">
              <p class="u-font-15 u-text-right">
                <strong>
                  {{ formatPrix(commande.attributes.montant_total_ttc) }}
                  &nbsp;€
                </strong>
              </p>
            </GridCol>
          </GridRow>
          <p
            v-if="commande.attributes.has_garantie"
            class="u-color-text-light u-font-14 u-font-500 u-text-left u-mt-xs u-mb-xs"
          >
            Ticket avec produit sous garantie
          </p>
          <Divider
            dotted
            class="u-m-none"
          />
          <div class="u-text-left u-mt-xs u-mb-xs">
            <div class="u-flex u-flex-align-center u-font-15">
              <Icon
                name="shop"
                variant="primary"
                size="sm"
                class="u-flex-shrink-none u-mr-xxs"
              />
              {{ commande.attributes.nom_magasin }}
            </div>
          </div>
          <div class="u-text-left">
            <BadgeStatus
              size="sm"
              status="success"
              class="u-ml-xxs"
            >
              Terminé
            </BadgeStatus>
          </div>
          <div
            v-if="commande.attributes.has_receipts"
            class="u-mt-xs"
          >
            <Divider
              dotted
              class="u-m-none"
            />

            <div
              v-if="commandeListReversed.length <= 3"
              class="u-flex u-flex-column u-flex-align-start u-text-left"
            >
              <template
                v-for="(ticket, index) in commandeListReversed"
                :key="index"
              >
                <Button
                  v-if="ticket.type == 'Ticket de caisse avec bon d\'achat' || ticket.type == 'Ticket de caisse'"
                  link
                  variant="primary"
                  class="u-mt-xs"
                  @click="ouvrirPdf(ticket.url_pdf)"
                >
                  <Icon
                    name="ticket-circle"
                    variant="primary"
                    size="xs40"
                    class="u-flex-shrink-none u-mr-xs"
                  />
                  Voir le {{ ticket.type.toLowerCase() }}
                </Button>
                <Button
                  v-else
                  link
                  variant="text-light"
                  class="u-mt-sm"
                  @click="ouvrirPdf(ticket.url_pdf)"
                >
                  Voir le {{ ticket.type == 'Ticket CB' ? 'ticket de carte bancaire' : ticket.type.toLowerCase() }}
                </Button>
              </template>
            </div>
            <div
              v-else
              class="u-mt-xs"
            >
              <DropDown
                dropdown-size="sm30"
                dropdown-position="left"
                icon-color="primary"
                link-button
              >
                <template #button-content>
                  <Icon
                    name="ticket-circle"
                    variant="primary"
                    size="xs40"
                    class="u-flex-shrink-none u-mr-xs"
                  />
                  <span class="u-font-14 u-color-primary">Voir tous mes tickets</span>
                </template>
                <DropDownItem
                  v-for="(ticket, index) in commandeListReversed"
                  :key="`${ticket.type}-${index}`"
                  size="md"
                  class="u-text-left u-pb-xs"
                >
                  <Button
                    v-if="ticket.type == 'Ticket de caisse avec bon d\'achat' || ticket.type == 'Ticket de caisse'"
                    link
                    variant="primary"
                    @click="ouvrirPdf(ticket.url_pdf)"
                  >
                    <Icon
                      name="ticket-circle"
                      variant="primary"
                      size="xs40"
                      class="u-flex-shrink-none u-mr-xs"
                    />
                    Voir le {{ ticket.type.toLowerCase() }}
                  </Button>
                  <Button
                    v-else
                    link
                    variant="text-light"
                    @click="ouvrirPdf(ticket.url_pdf)"
                  >
                    Voir le {{ ticket.type == 'Ticket CB' ? 'ticket de carte bancaire' : ticket.type.toLowerCase() }}
                  </Button>
                </DropDownItem>
              </DropDown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
.c-commande-overview-mobile__button {
  display: block;
  width: 100%;
  text-decoration: none;
}
</style>
